import { formatUserFacingError } from '@/lib/errors'
import { useCallback, useEffect, useState } from 'react'
import { adminEventsService } from '../services/admin.events.service'
import type { TicketOrderDocument, TicketDocument } from '@/types'

export function useAdminEventTickets(eventId: string) {
  const [orders, setOrders] = useState<Array<TicketOrderDocument & { id: string }>>([])
  const [tickets, setTickets] = useState<Array<TicketDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [tick, setTick] = useState(0)

  const refresh = useCallback(() => setTick((t) => t + 1), [])

  useEffect(() => {
    if (!eventId) return
    setLoading(true)
    setError(null)
    Promise.all([
      adminEventsService.getOrdersForEvent(eventId),
      adminEventsService.getTicketsForEvent(eventId),
    ])
      .then(([o, t]) => {
        setOrders(o)
        setTickets(t)
      })
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load tickets')),
      )
      .finally(() => setLoading(false))
  }, [eventId, tick])

  return { orders, tickets, loading, error, refresh }
}
